import Vue from "vue";
import App from "./App";
import router from "./router/index.js";

import "swiper/dist/css/swiper.min.css";

import "babel-polyfill";

import Es6Promise from 'es6-promise'
Es6Promise.polyfill();


new Vue({
    el: "#app",
    router: router,
    render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js


// WEBPACK FOOTER //
// ./src/main.js